import { format, isValid } from 'date-fns'
import type { WorkPostSheetFormValues } from '../providers/FormProvider'
import { AiSuggestedWorkPostSheet, WorkPostSheetItemTypesEnum } from '../types'
import { isDateWPSItem } from './isDateWPSItem'
import { isMaternityProtectionMeasuresWPSItem } from './isMaternityProtectionMeasuresWPSItem'
import { isTextWPSItem } from './isTextWPSItem'

const commentToString = (comment: string | Date | null | undefined): string => {
  if (comment instanceof Date) {
    return isValid(comment) ? format(comment, 'yyyy-MM-dd') : ''
  }
  return comment || ''
}

// An item counts as AI suggested while the form would still submit it exactly as AI suggested it.
// Mirrors the item rules of wpsFormValuesToWorkPostSheetInput.
export const isAiSuggestedWPSItem = (
  name: WorkPostSheetItemTypesEnum,
  values: WorkPostSheetFormValues,
  aiSuggestedWorkPostSheet: AiSuggestedWorkPostSheet | null | undefined
): boolean => {
  const suggestedItem = aiSuggestedWorkPostSheet?.items.find(
    item => item.name === name
  )
  const item = values.items.find(item => item.name === name)

  if (!suggestedItem || !item) {
    return false
  }

  if (
    isMaternityProtectionMeasuresWPSItem(name) &&
    !values.maternityProtectionMeasuresRequired
  ) {
    return false
  }

  const comment = commentToString(item.comment)
  const suggestedComment = suggestedItem.comment || ''

  // date and text items have no checkbox, they are submitted when they have a comment
  if (isDateWPSItem(name) || isTextWPSItem(name)) {
    return !!comment && comment === suggestedComment
  }

  return item.checked && comment === suggestedComment
}
